import { headingColor2, homeColor } from "./ColorCodes";

export const styles = {
  container: {
    width: '100%',
  },
  listItemIcon: {
    svg: {
      width: '1vw'
    }
  },
  heading2: {
    color: headingColor2,
    fontSize: '16px',
    fontWeight: '600'
  },
  homeSection1: {
    padding: '1vw 11vw',
    minHeight: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  homeSection1Title: {
    fontSize: '25px',
    color: '#581845',
  },
  button1: {
    width: '115px',
    height: '36px',
    flexShrink: 0,
    borderRadius: '8px',  
    backgroundColor: '#FF9A00',  
    // borderColor: homeColor.secondary,
    color: '#fff',
    textTransform: 'none',
      fontSize: '14px',
    transition: 'background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: homeColor.secondary, 
      borderColor: homeColor.secondary,
      color: '#fff' 
    },
    
    '@media (max-width: 786px)': {
      width: '102px',
      height: '32px',
      fontSize: '13px'
    },
    
    '@media (max-width: 600px)': { 
      width: '63px',
      height: '20px',
      borderRadius: '4px',
      fontSize: '7px',

    }
  },
  
  button2: {
    borderColor: homeColor.secondary,
    transition: 'background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: '#2793F2'
    }
  },
  homeSubMenu: {
    fontSize: '10px',
    transition: 'background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: 'red'
    }
  },
  homeFooterIcons: {
    fontSize: '18px',
    // width: '22px',
    verticalAlign: 'middle',
    marginRight: '0.7vw',
    color: homeColor.footerIcon,
  },

  // Responsive styles
  '@media (min-width: 1200px)': {
    container: {
      width: '100%',
    },
  },
  
  '@media (max-width: 1100px)': {
    meetingScheduler: {
      flexDirection: 'column',
    },
  },
  
  '@media (max-width: 500px)': {
    appointmentAd: {
      flexDirection: 'column',
      
    }
  },
};
